<template>
  <div class="py-4">
    <div class="flex justify-between">
      <div class="flex">
        <IconsCircleCtrlRight class="flex-shrink-0 mt-1 w-3 h-3" />
        <div class="ml-[2px] w-[244px]">
          <p class="text-sm text-start font-semibold text-color-black">{{ item.test_title }}</p>
          <p class="text-[13px] text-gray-600 text-color-black">{{ item.service_title }}</p>
        </div>
      </div>

      <div class="text-right whitespace-nowrap">
        <p class="text-sm text-color-black line-through" v-if="item.discount && item.discount > 0">
          {{ $formatCurrency(item.price?.toFixed(2)) }}
        </p>
        <p class="text-sm font-semibold text-color-black">
          {{
            item.discount && item.discount > 0
              ? $formatCurrency(item.net_price?.toFixed(2))
              : $formatCurrency(item.price?.toFixed(2))
          }}
        </p>
        <p
          class="text-sm font-semibold text-color-black mt-1 flex items-center justify-end"
          v-if="item.discount && item.discount > 0"
        >
          <IconsDiscount />
          <span class="ml-1">{{ item.discount }}% off</span>
        </p>
      </div>
    </div>

    <div class="flex justify-between items-center mt-8">
      <BaseQuantitySelector
        :modelValue="item.quantity"
        @update:model-value="updateQuantity"
        custom-class="p-1 gap-[15px] border border-secondary rounded inline-flex items-center bg-white"
      />

      <button type="button" @click="removeItem" class="p-2 text-red-500 hover:text-red-700 transition-colors">
        <IconsTrashIcon />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCartStore, type CartItem } from "@/stores/cart";
import type { PropType } from "vue";

const props = defineProps({
  item: {
    type: Object as PropType<CartItem>,
    required: true,
  },
});

const cartStore = useCartStore();

function updateQuantity(quantity: number) {
  if (!props.item.id) {
    return;
  }

  cartStore.updateItemQuantity(props.item.id, quantity);
}

function removeItem() {
  if (!props.item.id) {
    return;
  }

  cartStore.removeItem(props.item.id);
}
</script>

<style scoped>
.text-color-black {
  color: #253754;
}
</style>
